import { Page } from "commonAssets/pages/Page";
import {
    loading,
    outputDiv,
    userLanguage,
    i18n,
} from "commonAssets/js/constants";
import { createElement, loadingGif } from "commonAssets/js/helpers";
import { makeStandardContactPage } from "commonAssets/pages/Page/contact";
import { renderLegalOptionsTable } from "commonAssets/pages/Page/home";

export class CustomPage extends Page {
    banks_broker_institutions() {
        const Pages = this.pages;
        Pages.forEach((page) => {
            if (this.slug !== page.PageName) return;

            const PageTitle = createElement(
                "h2",
                { class: "PageTitle" },
                [],
                `Instructions for Filing an Electronic Claim`
            );
            const Separator = createElement("hr");
            const Instructions = createElement(
                "div",
                { id: "efiling-instructions" },
                [],
                `           
            <h4 class="mt-3 mb-3"><strong>OVERVIEW</strong></h4>
            <p>Electronic claim submission is available to Banks, Brokers, and other Institutions or claim prepares filing on behalf of themselves or others that purchased or otherwise acquired Inotiv common stock between September 21, 2021, and May 20, 2022, inclusive; or held shares of Inotiv common stock as of October 4, 2021, and were entitled to vote on matters necessary to effectuate Inotiv&rsquo;s acquisition of Envigo at a special meeting of Inotiv shareholders on November 4, 2021.</p>
            <p class="text-decoration-underline">Important</p>
<ul>
<li>Submissions must be entered via the Electronic Claim Portal</li>
<li>Submissions missing documentation and/or not in compliance with the Electronic Filing Instructions may be rejected, in whole or in part</li>
<li>Submissions are not considered to be received unless confirmation is provided via email. If you do not receive confirmation within 10 days of your submission, please email <a href="mailto:info@InotivSecuritiesSettlement.com?subject=%28Enter%20your%20filing%20entity%29%20%7C%20Inotiv%20Securities%20%7C%20Missing%20Confirmation">info@InotivSecuritiesSettlement.com</a> with the subject: (Enter your filing entity) | Inotiv Securities Settlement | Missing Confirmation</li>
</ul>            <hr>
            <h4 class="mt-3 mb-3"><strong>ELECTRONIC CLAIM PORTAL</strong></h4>
            <p><span style="color: red;">⚠</span> <a target="_blank" href="third-party-filer">Click here to access the Electronic Claim Portal</a></p>
            <hr>
            <h4 class="mt-3 mb-3"><strong>DATA FILES</strong></h4>
            <p>Download and complete the Beneficial Owner template and Transaction template as directed in the Electronic Claim Filing Instructions.</p>
            <p><span style="color: red;">⚠</span> <a target="_blank" href="https://angeion-public.s3.us-east-1.amazonaws.com/www.inotivsecuritiessettlement.com/docs/Electronic%20Claim%20Filing%20Instructions.pdf">Click here to download the Electronic Filing Instructions</a></p>
            <p><span style="color: red;">⚠</span> <a target="_blank" href="https://angeion-public.s3.us-east-1.amazonaws.com/www.inotivsecuritiessettlement.com/docs/Beneficial%2BOwner%2BInformation%2Btemplate.csv">Click here to download the Beneficial Owner Template</a></p>
            <p><span style="color: red;">⚠</span> <a target="_blank" href="https://angeion-public.s3.us-east-1.amazonaws.com/www.inotivsecuritiessettlement.com/docs/Transaction%2BInformation%2Btemplate.csv">Click here to download the Transaction Template</a></p>
            <hr>
            <h4 class="mt-3 mb-3"><strong>DOCUMENTATION</strong></h4>
            <ul id='banks-broker-institutions-docs'>
                <li>
                    <strong>Claim Form</strong> <span style="color: red;">⚠</span> <a target="_blank" href="https://angeion-public.s3.amazonaws.com/www.inotivsecuritiessettlement.com/docs/Proof%20of%20Claim%20and%20Release%20Form.pdf">Click here to download the Claim Form</a>
                    <ul>
                      <li>Please complete the Claimant Information page (Part II) and complete the signature portion on page 6 under Section IV - Release of Claims and Signature.</li>
                      <li>One Claim Form will serve as the “master” for all Claims provided in the electronic data files.</li>
                    </ul>
                </li>
                <li>
                    <strong>Proof of Authority to File</strong>
                    <ul><li>Please provide a current document verifying you are authorized to file and sign claims on behalf of the Claimants that you have submitted Claims for.</li></ul>
                </li>
                <li>
                    <strong>Signature Verification</strong>
                    <ul><li>Please provide verification that the individual signing the Claim Form is authorized to do so, including, but not limited to By-Laws, Corporate Resolution, or a notarized Affidavit.</li></ul>
                </li>
                <li>
                    <strong>Declaration of Data Source</strong>
                    <ul><li>Please provide a notarized Affidavit or signed letter on Company letterhead that lists the number of separate claims and transactions submitted; attests to the source, truth, and accuracy of the data for each claim; and is executed by an authorized signatory listed on the signature verification and includes the capacity of the signatory.</li></ul>
                </li>
                <li>
                    <strong>Additional Documentation May Be Requested</strong>
                </li>
            </ul>
            `
            );

            const pageElement = createElement("div", { class: "page" }, [
                PageTitle,
                Separator,
                Instructions,
            ]);
            outputDiv.appendChild(pageElement);
        });
        loadingGif(loading, "hide", 250);
    }
}

export const contactPage = (params) => {
    console.log("[Contact Page] ...");
    // define the constants
    const slug = params.slug;
    const page = params.pages.find((page) => page.PageName === slug);
    // define the elements
    const pageTitle = createElement(
        "h2",
        { class: "page-title mt-2 mb-4" },
        [],
        page.PageTitle
    );
    const pageContent = createElement("div", { class: "page-content row" });
    const pageDiv = createElement("div", { class: "page-div" }, [
        pageTitle,
        pageContent,
    ]);
    const divImptDates = createElement(
        "div",
        {
            class: "my-5 mx-auto",
            id: "ImportantDates",
            style: "max-width: 512px;",
        },
        [],
        params.dates.card()
    );
    const pageColumns = createElement("div", { class: "col-12 col-md-7" });
    // contact column
    if (page.PageContent.length > 0) {
        // make standard contact page
        makeStandardContactPage(params, page, userLanguage, pageColumns);
        pageContent.appendChild(pageColumns);
    } else {
        const contactInfoNa = createElement(
            "p",
            { class: "fst-italic" },
            [],
            `No contact information found.`
        );
        pageColumns.appendChild(contactInfoNa);
        pageContent.appendChild(pageColumns);
    }
    // remove the my-5 and mx-auto classes from the divImptDates element
    if (divImptDates.classList.contains("my-5", "mx-auto")) {
        divImptDates.classList.remove("my-5", "mx-auto");
    }
    // important dates column
    const imptDatesColumn = createElement("div", { class: "col-12 col-md-5" }, [
        divImptDates,
    ]);
    pageContent.appendChild(imptDatesColumn);
    outputDiv.appendChild(pageDiv);
    loadingGif(loading, "hide", 250);
};

export const homePage = (params) => {
    console.log("[Home] ...");
    // Get the page slug from the URL and initialize the page object
    const slug = params.slug;
    const page = params.pages.find((page) => page.PageName === slug);
    // HTML elements for the page
    const pageTitle = createElement(
        "h2",
        {
            class: "page-title mt-2 mb-4 d-none",
            "aria-label": i18n.getTranslation("home_page_aria_title"),
        },
        [],
        page.PageTitle
    );
    const pageBody = createElement("div", { class: "page-body" });
    const pageAlert = createElement(
        "div",
        {
            class: "alert border-dark bg-light text-dark mb-3 pt-4 text-center",
            id: "pageAlert",
        },
        [],
        page.PageAlert
    );
    const pageHeader = createElement(
        "p",
        { class: "text-center h2 my-5 pageHeader", id: "pageHeader_" + slug },
        [],
        page.PageHeader
    );
    const pageSubHeader1 = createElement(
        "p",
        {
            class: "text-center fw-bold fst-italic pageSubHeader1",
            id: "pageSubHeader1_" + slug,
        },
        [],
        page.PageSubHeader1
    );
    const pageSubHeader2 = createElement(
        "p",
        {
            class: "text-center fst-italic pageSubHeader2",
            id: "pageSubHeader2_" + slug,
        },
        [],
        page.PageSubHeader2
    );
    const pageContent = createElement(
        "div",
        { class: "mb-3 pageContent", id: "pageContent_" + slug },
        [],
        page.PageContent
    );
    const pageFooter = createElement(
        "div",
        { class: "py-3", id: "pageFooter" },
        [],
        page.PageFooter
    );
    // Legal Rights and Options Table
    const optionsDIV = renderLegalOptionsTable(slug, page);
    const pageElement = createElement("div", { class: "page", id: slug }, [
        Boolean(page.PageAlert) ? pageAlert : "",
        pageHeader,
        pageSubHeader1,
        pageSubHeader2,
        optionsDIV,
        pageFooter,
        pageContent,
    ]);
    const pageDiv = createElement("div", { class: "home-container" }, [
        pageTitle,
        pageBody,
    ]);
    // Append the page elements to the output div
    outputDiv.appendChild(pageElement);
    outputDiv.appendChild(pageDiv);
    loadingGif(loading, "hide", 100);
};

export const fixFaqs = () => {
    const faq2Content = document.querySelector(
        "#flush-collapse-2 > .accordion-body"
    );
    faq2Content.innerHTML = `<p>Inotiv is a contract research organization specializing in nonclinical and analytical drug discovery and development services to customers in the pharmaceutical, chemical and medical device industries, as well as to academic and governmental research institutions. This Action arises out of alleged material misrepresentations and omissions concerning Defendant Inotiv&rsquo;s November 2021 acquisition of Envigo. The alleged material misrepresentations and omissions upon which this case centers are from the period between September 21, 2021, and May 20, 2022, inclusive.</p>

<p>On June 23, 2022, an initial complaint was filed in the United States District Court for the Northern District of Indiana against Inotiv and two of its officers, Defendants Leasure and Taylor, asserting claims for violations of Section 10(b) of the Securities Exchange Act of 1934 and Rule 10b-5 promulgated thereunder.</p>

<p>Following the filing of the initial complaint, Lead Plaintiff Oklahoma Police Pension and Retirement System (&ldquo;Oklahoma Police&rdquo;) filed a Motion for Appointment as Lead Plaintiff and Approval of Selection of Counsel on August 22, 2022. On September 12, 2022, the Court appointed Oklahoma Police as Lead Plaintiff in the Action pursuant to the Private Securities Litigation Reform Act of 1995 (&ldquo;PSLRA&rdquo;). The Court also approved Oklahoma Police&rsquo;s selection of Berman Tabacco as Lead Counsel and CohenMalad, LLP as Liaison Counsel on behalf of Lead Plaintiff and the proposed class.</p>

<p>On November 14, 2022, Lead Plaintiff filed and served an Amended Class Action Complaint for Violations of the Federal Securities Laws against the same defendants, in addition to Sagartz and Wilbourn, which asserted the following claims: (1) Violations of Section 10(b) of the Exchange Act and Rule 10b-5 promulgated thereunder (against all Defendants); (2) Violations of Section 14(a) of the Exchange Act and Rule 14a-9 promulgated thereunder (against Defendants Inotiv, Leasure, and Taylor); and (3) &ldquo;control person&rdquo; claims under Section 20(a) of the Exchange Act (against Defendants Leasure and Taylor). Lead Plaintiff subsequently sought&mdash;and obtained&mdash;leave of court to file a First Amended Class Action Complaint for Violations of the Federal Securities Laws (the &ldquo;FAC&rdquo;), which was filed on November 23, 2022. The FAC is the operative complaint in this Action.</p>

<p>On January 27, 2023, Defendants moved to dismiss the FAC (the &ldquo;Motion&rdquo;). Lead Plaintiff opposed Defendants&rsquo; motion on March 28, 2023. On March 29, 2024, the Court entered an Opinion and Order denying, in part, the Defendants&rsquo; Motion. In its Order, the Court found that Lead Plaintiff had plausibly alleged violations of Sections 10(b), 14(a), and 20(a) of the Exchange Act. The Court did, however, narrow Plaintiff&rsquo;s Section 10(b) claim&mdash;holding that Plaintiff had failed to meet its burden to allege facts supporting a strong inference of scienter regarding Defendants&rsquo; alleged misrepresentations and omissions concerning Inotiv&rsquo;s &ldquo;non-human primate&rdquo; business. The Court also narrowed Plaintiff&rsquo;s proposed class period from the originally-proposed September 21, 2021, through November 16, 2022, period to the period of September 21, 2021, through May 20, 2022, which is the proposed Settlement Class Period here. On May 31, 2024, Defendants filed their Answer to the FAC.</p>

<p>On April 29, 2024, the Court issued a Scheduling Order (the &ldquo;Scheduling Order&rdquo;) establishing certain case management deadlines and otherwise approving and adopting all other dates and deadlines through the close of discovery set forth in the April 24, 2024, Rule 26(f) Report of Parties&rsquo; Planning Meeting. Shortly thereafter, the Parties commenced fact discovery. After Lead Plaintiff served its initial document requests on the Defendants on May 13, 2024, the Parties engaged in multiple discovery conferences. Defendants began their production of documents to Lead Plaintiff in late September 2024.</p>

<p>Against this backdrop and in anticipation of an upcoming January 2025 deadline to identify a mediator set forth in the Scheduling Order, the Parties began to discuss the possibility of mediation in September 2024. Shortly thereafter, the Parties scheduled an in-person mediation to take place in New York City on February 24, 2025, in New York City before a nationally-recognized mediator, Mr. Robert A. Meyer, Esq. (the &ldquo;February 2025 Mediation Session&rdquo;). Prior to the February 2025 Mediation Session, the Parties submitted detailed mediation statements. While the February 2025 Mediation Session did not result in a settlement, the parties continued settlement discussions over the course of the months that followed with Mr. Meyer&rsquo;s guidance and supervision. On September 25, 2025, the Parties reached an agreement to settle the Action for $8,750,000, subject to approval by this Court.</p>

<p>Defendants deny each and all of the claims and contentions of wrongdoing alleged by Lead Plaintiff in the Action. Defendants contend that they did not make any materially false or misleading statements, that they disclosed all material information required to be disclosed by the federal securities laws, and that any alleged misstatements or omissions were not made with the requisite intent or knowledge of wrongdoing. Defendants also maintain that they have meritorious defenses to all claims alleged in the Action.</p>

<p>On October 7, 2025, the Court preliminarily approved this Settlement, authorized the Notice to be disseminated to potential Settlement Class Members, and scheduled the Settlement Hearing to consider whether to grant final approval to the Settlement.</p>
`;
};
